import { render, staticRenderFns } from "./FromsApp.vue?vue&type=template&id=51791980&scoped=true"
import script from "./FromsApp.vue?vue&type=script&lang=js"
export * from "./FromsApp.vue?vue&type=script&lang=js"
import style0 from "./FromsApp.vue?vue&type=style&index=0&id=51791980&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51791980",
  null
  
)

export default component.exports